import { render, staticRenderFns } from "./TabRejected.vue?vue&type=template&id=8561fb84&"
import script from "./TabRejected.vue?vue&type=script&lang=js&"
export * from "./TabRejected.vue?vue&type=script&lang=js&"
import style0 from "./TabRejected.vue?vue&type=style&index=0&id=8561fb84&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports